import React from 'react';

import { GetInvoiceIssuerDto } from '../../../common/spdCore/autogenerated/spdApiClient/models/GetInvoiceIssuerDto';
import { Grid } from '../../../common/components/Grid/Grid';
import {
  GridCountFunction,
  GridGetterFunction,
} from '../../../common/components/Grid/GridDataTypes';

interface InvoiceIssuerSearchProps {
  getData: GridGetterFunction;
  getCount: GridCountFunction;
  refresh?: boolean;
  onRowClick: (key: string) => Promise<void> | void | undefined;
}

export const invoiceIssuerForGrid = (issuer: GetInvoiceIssuerDto) => {
  return {
    key: issuer.id,
    values: {
      'invoiceIssuer.name': issuer.name,
      'invoiceIssuer.nip': issuer.nip,
      'invoiceIssuer.symbol': issuer.symbol,
      'invoiceIssuer.isDefault': issuer.isDefault ? 'Tak' : '',
      'invoiceIssuer.active': issuer.active ? 'Tak' : 'Nie',
    },
  };
};

export const InvoiceIssuerSearch: React.FC<
  InvoiceIssuerSearchProps
> = props => {
  const columns = [
    { header: 'Nazwa', property: 'invoiceIssuer.name' },
    { header: 'NIP', property: 'invoiceIssuer.nip' },
    { header: 'Symbol faktury', property: 'invoiceIssuer.symbol' },
    { header: 'Domyślny', property: 'invoiceIssuer.isDefault' },
    { header: 'Aktywny', property: 'invoiceIssuer.active' },
  ];

  return (
    <Grid
      getData={props.getData}
      getDataCount={props.getCount}
      columns={columns}
      showFilter={true}
      initialOrderColumn="invoiceIssuer.name"
      availablePageSizes={[10, 20, 50]}
      emptyGridMessage="Brak wystawców faktur w systemie"
      enableMultiSelect={false}
      refresh={props.refresh}
      onRowClick={props.onRowClick}
    />
  );
};
